'use strict';

var langCodes = require('./langs.convert');

/* eslint no-continue: 0 */

/**
 * Select next file.
 *
 * @param {Object} list - files for play
 * @param {Object} language - actual playing language
 * @param {Object} file - actual playing file data
 */
module.exports = function ( list, language, file ) {
    var selected = null,
        index;

    if ( list && list.length > 0 ) {
        if ( list.length === 1 ) {
            selected = list[0];
        } else {
            if ( language.length && language[0] !== '' ) {
                language = language[0];
            } else if ( file.languages.length ) {
                language = file.languages[0];
            }

            language = langCodes[language];

            for ( index = 0; index < list.length; index++ ) {
                if ( list[index].value ) {
                    if (
                        list[index].value.languages.indexOf(language[0]) !== -1
                        || (language[1] && list[index].value.languages.indexOf(language[1]) !== -1)
                    ) {
                        if ( list[index].value.quality.width === file.quality.width ) {
                            selected = list[index];
                            break;
                        }

                        if ( list[index].value.quality.width > file.quality.width ) {
                            selected = {
                                value: list[index].value,
                                index: index
                            };
                            continue;
                        }

                        selected = {
                            value: list[index].value,
                            index: index
                        };
                        break;
                    }
                }
            }
        }
    }

    return selected;
};
